<template>
  <div class="clearfix">

  <!-- Nombres -->
    <vs-input
      v-validate="'required|min:3'"
      data-vv-validate-on="blur"
      label-placeholder="Nombres"
      name="Nombre"
      placeholder="Nombres"
      v-model="firstNames"
      class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('Nombres') }}</span>

  <!-- Apellidos -->
    <vs-input
      v-validate="'required|min:2'"
      data-vv-validate-on="blur"
      label-placeholder="Apellidos"
      name="Apellidos"
      placeholder="Apellidos"
      v-model="lastNames"
      class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('Apellidos') }}</span>

  <!-- Sexo -->
    <v-select 
      class="mt-6"
      :options="['male','female']" v-model="sex" :dir="$vs.rtl ? 'rtl' : 'ltr'" 
      v-validate="'required'" placeholder="Sexo"
      name="Sexo"
    />
    <span class="text-danger text-sm mb-2">{{ errors.first('Sexo') }}</span>

  <!-- Fecha de Nacimiento -->
    <datepicker format="yyyy-MM-dd" class="mt-6" v-model="DoB" placeholder="Fecha de Nacimiento"
      v-validate="'required'" name="fecha" :disabledDates="disabledDates"
    ></datepicker>
    <span class="text-danger text-sm mb-2">{{ errors.first('fecha') }}</span>



  <!-- Celular -->
      <vs-input
      v-validate="'required|alpha_dash|min:3'"
      data-vv-validate-on="blur"
      label-placeholder="Número de Celular"
      name="Celular"
      placeholder="Celular"
      v-model="cel"
      class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('Celular') }}</span>


  <!-- Especialidad -->
    <vs-input
      v-validate="''"
      data-vv-validate-on="blur"
      label-placeholder="Especialidad"
      name="Especialidad"
      placeholder="Especialidad"
      v-model="specialty"
      class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('Especialidad') }}</span>

    <vs-input
      v-validate="'required|email'"
      data-vv-validate-on="blur"
      name="Correo"
      type="email"
      label-placeholder="Correo"
      placeholder="Correo"
      v-model="email"
      class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('Correo') }}</span>

    <vs-input
      ref="password"
      type="password"
      data-vv-validate-on="blur"
      v-validate="'required|min:6|max:15'"
      name="Contraseña"
      label-placeholder="Password"
      placeholder="Password"
      v-model="password"
      class="w-full mt-6" />
    <span class="text-danger text-sm">{{ errors.first('Contraseña') }}</span>

    <vs-input
      type="password"
      v-validate="'min:6|max:15|confirmed:password'"
      data-vv-validate-on="blur"
      data-vv-as="password"
      name="confirm_password"
      label-placeholder="Confirmar Contraseña"
      placeholder="Confirmar Contraseña"
      v-model="confirm_password"
      class="w-full mt-6 mb-6" />
    <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>
    <a href="/pages/doctor/terms-cond" target="_blank" class="mt-5 ml-1">
        <feather-icon icon="ExternalLinkIcon" class="mr-2" />
        Consultar términos y Condiciones
    </a>
    <vs-checkbox v-model="isTermsConditionAccepted" class="mt-5 mb-3">Acepto los términos y condiciones.</vs-checkbox>
    <vs-button  type="border" to="/pages/login" class="mt-3 mb-4">Iniciar Sesión</vs-button>
    <vs-button class="float-right mt-3 mb-4" @click="registerUser" :disabled="!validateForm">Crear Cuenta</vs-button>
  </div>
</template>

<script>
// imports
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker';


export default {
  data () {
    return {
      firstNames: '',
      lastNames: '',
      cel: '',
      sex: '',
      DoB: '',
      specialty: '',
      email: '',
      password: '',
      confirm_password: '',
      isTermsConditionAccepted: true,
      disabledDates: {
        from: new Date(2010, new Date().getMonth(), 1), // Disable all dates after specific date
      }
    }
  },
  components: {
    vSelect,
    Datepicker
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.firstNames !== '' && this.lastNames !== ''
        && this.email !== '' && this.DoB !== ''
        && this.sex !== '' && this.password !== '' && this.confirm_password !== ''  
        && this.isTermsConditionAccepted === true
    }
  },
  methods: {
    checkLogin () {
      // If user is already logged in notify
      if (this.$store.state.auth.isUserLoggedIn()) {

        // Close animation if passed as payload
        // this.$vs.loading.close()

        this.$vs.notify({
          title: 'Login Attempt',
          text: 'You are already logged in!',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })

        return false
      }
      return true
    },
    registerUser () {
      // If form is not validated or user is already login return
      if (!this.validateForm || !this.checkLogin()) return

      const payload = {
        userDetails: {
          first_name: this.firstNames,
          last_name: this.lastNames,
          email: this.email,
          dob: this.DoB,
          gender: this.sex,
          phone: [this.cel],
          password: this.password,
          notification_prefs: ['email', 'sms'],
          specialty: this.specialty,
          // assigning a pre-fixed player_id to avoid notification errors (if user allows OneSignal in the future this will be updated) 
          player_id: '46783a77-d0fc-468f-929f-6aaabf70f2ad'
        },
        notify: this.$vs.notify
      }
      console.log(payload);
      // Firebase registration
      // this.$store.dispatch('auth/registerUser', payload)
      
      // Evolugy Registration
      this.$store.dispatch('auth/registerUserEvolugy', payload);

    }
  }
}
</script>
